import { Component, Story, Knobs, Icons, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  icon: {
    default: 'Bug',
    editor: 'dropdown',
    editorOptions: Icons,
  },
  accent: {
    default: 'title',
    editor: 'dropdown',
    editorOptions: Accents,
  },
  size: {
    default: '50',
    editor: 'dropdown',
    editorOptions: ['10', '50', '100', '200', 'default', 'medium', 'large', 'extraLarge'],
  },
};

const PlaygroundKnobsV3: Knobs = {
  ...PlaygroundKnobs,
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-icon-svg where you can change all the attributes',
  coreComponent: {
    html: `<tag-icon-svg{{...knobs}}></tag-icon-svg>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-icon-svg{{...knobs}}></tag3-icon-svg>`,
    knobs: PlaygroundKnobsV3,
  },
  reactWrapper_v3: {
    jsx: `<Tag3IconSvg{{...knobs}} />`,
    knobs: PlaygroundKnobsV3,
  },
};

export const TagIconSvgDocs: Component = {
  type: 'component',
  name: 'icon-svg',
  description:
    'Renders an svg icon. If you just want to display one of the standard icons, this is a little lighter weight than using tag-icon',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'icon',
      description: 'The name of the icon, or an image url reference',
      type: 'Icon | string',
    },
    {
      name: 'accent',
      description: 'The colour of the icon',
      type: 'string',
    },
    {
      name: 'size',
      description: ' The size of the icon',
      type: 'string',
      default: 'default',
    },
    {
      name: 'iconStyle',
      description: ' A CSS JSON string to apply to the internal element. DEPRECATED in v3',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
